import React from 'react';
import { marketingVideos, localMarketingVideos } from '../../config/marketingMedia';

export default function VideoSlot({ name, audience = 'agency' }) {
  const videos = audience === 'local' ? localMarketingVideos : audience === 'agency' ? marketingVideos : null;
  const video = videos && Object.prototype.hasOwnProperty.call(videos, name) ? videos[name] : null;
  if (!video || (audience === 'local' && !video.embedUrl && !video.src)) return null;
  return (
    <figure className="overflow-hidden rounded-3xl border border-[#409FA1]/30 bg-[#101F1F] text-white">
      {video.embedUrl ? (
        <div className="relative aspect-video w-full"><iframe src={video.embedUrl} title={video.title} loading="lazy" allow="fullscreen; picture-in-picture" allowFullScreen className="absolute inset-0 h-full w-full border-0" /></div>
      ) : video.src ? <video controls playsInline preload="metadata" className="block aspect-video w-full object-contain" aria-label={video.title}><source src={video.src} />Your browser does not support video.</video> : (
        <div className="flex aspect-video flex-col justify-center p-7 sm:p-10">
          <span className="font-michroma text-[10px] uppercase tracking-widest text-[#F6D541]">Video coming soon</span>
          <span className="mt-5 text-2xl font-bold sm:text-3xl">{video.title}</span>
          <span className="mt-5 text-sm text-white/70">With Joe Moore · {video.duration}</span>
        </div>
      )}
      <figcaption className="border-t border-white/15 p-5 text-sm leading-6 text-white/80">{video.summary}</figcaption>
    </figure>
  );
}